// Estatus de un juego de torneo: etiquetas, estilos de badge y opciones de select.
// Fuente única (antes duplicado en varias pantallas).
export const ESTATUS_JUEGO_LABELS = {
  programado: 'Programado',
  finalizado: 'Finalizado',
  cancelado: 'Cancelado',
  pospuesto: 'Pospuesto',
};

export const ESTATUS_JUEGO_STYLES = {
  programado: 'border-amber-500/30 bg-amber-500/10 text-amber-600',
  finalizado: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-600',
  cancelado: 'border-rose-500/30 bg-rose-500/10 text-rose-600',
  pospuesto: 'border-indigo-500/30 bg-indigo-500/10 text-indigo-600',
};

export const ESTATUS_JUEGO_OPTIONS = [
  { value: 'programado', label: 'Programado' },
  { value: 'finalizado', label: 'Finalizado' },
  { value: 'pospuesto', label: 'Pospuesto' },
  { value: 'cancelado', label: 'Cancelado' },
];
